import {ResourceParams, resources} from "../../../../models/resource/resources";

export const advertisementPackagesResourceType: ResourceParams = resources['advertisement-packages'];

export const deleteConfirmationParams = {
  titleText: 'Отвязать рекламу',
  description: 'Вы действительно хотите отвязать рекламу?',
  buttonWarmText: 'Отвязать',
}

export const defaultRecordsAdvertisementPackagesParams = {
  recordCalendarId: 0,
  advertisementPackageId: 0
}
